import axios from "axios";
import { getAxiosBaseURL } from "../config/apiBase";

const baseURL = getAxiosBaseURL();

export default axios.create({
  baseURL,
});

export const instance = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
